































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
import edit from './withdrawEdit.vue';
@Component({
    components: { edit }
})
export default class suppliermanage extends pagelist {
    //request 请求参数
    get DealerServiceProxy() {
        return new proxy.MerchantWithdrawOrderServiceProxy();
    }
    fxarr = []; //所有分销商
    input = new proxy.MerchantWithdrawOrderPageInputDto();
    sub_id = 0;
    createOrEditShow = false;
    auditrange = [];
    createrange = []
    columns = [
        {
            type: 'selection',
            width: 60,
            align: 'center'
        },

        {
            title: '提现单号',
            key: 'orderNo',
        },
       
        {
            title: '提现金额',
            key: 'money'
        },
        {
            title: '姓名',
            key: 'bankName'
        },
        // {
        //     title: '支付宝名称',
        //     key: 'aliName'
        // },
        {
            title:'银行卡号',
            key:'bankNo'
        },
        {
            title:'银行',
            key:'bank'
        },
        {
            title:"支行名称",
            key:'bankZhiHang'
        },
        {
            title:'所属省份',
            key:'bankProvince'
        },
        {
            title: '状态',
            slot: 'auditStatus'
        },
        {
            title: '创建时间',
            slot: 'creationTime',
        },
        {
            title: '审核时间',
            slot: 'auditTime'
        },
       
        // {
        //     title: '申请凭证',
        //     slot: 'applyVoucher',
        //     width: 150
        // },
        // {
        //     title: '拒绝原因',
        //     key: 'refuseReason'
        // }
    ];
    create() {
        this.createOrEditShow = true;
        this.sub_id = undefined;
    }
    showpic(url) {
        var showpic = this.$refs.showpic as any;
        showpic.larget(url);
    }
    exportrecord() {
        if (this.selectedDataItems.length > 0) {
            this.input.ids = this.selectedDataItems.map(x => {
                return x.id;
            });
        }
        //   this.DealerServiceProxy.exportRecharges(this.input).then(x => {
        //     location.href =
        //       AppConsts.remoteServiceBaseUrl +
        //       'File/DownloadTempFile?FileToken=' +
        //       x.fileToken +
        //       '&fileName=' +
        //       x.fileName +
        //       '&fileType=' +
        //       x.fileType;
        //   });
    }

    fetchDataList(
        request: PagedFilterAndSortedRequest,
        pageNumber: number,
        finishedCallback: Function
    ): void {
        this.input.skipCount = request.skipCount;
        this.input.maxResultCount = request.maxResultCount;
        this.input.sorting = request.sorting;
 
        this.DealerServiceProxy.queryModelList(this.input).then(x => {
            this.dataList = x.items;
            console.log(x.items);
            this.showPaging(x);
        });
    }

    getpage() {
        this.OnInit();
    }
    async created() {

        this.getpage();
    }
}
